module.exports = __webpack_public_path__ + "static/img/icon_drawer.afcb2d4f.png";